"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitySerializer = exports.DefaultSerializationSettings = exports.PropertyConverter = exports.IgnoreProperty = void 0;
var type_1 = require("./type");
var helpers_1 = require("./helpers");
exports.IgnoreProperty = {
    key: "ignore",
    value: "ignore"
};
/**
 * Allows transformation of the serialized name and value of a model property.
 */
var PropertyConverter = /** @class */ (function () {
    function PropertyConverter() {
    }
    /**
     * @param context The `Entity` containing the specified property.
     * @param prop The property being serialized/deserialized.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PropertyConverter.prototype.shouldConvert = function (context, prop) {
        return true;
    };
    /**
     * Return `IgnoreProperty` to prevent serialization of the property.
     * @param context The `Entity` containing the specified property.
     * @param prop The current property being serialized.
     * @param value The value of the property on the entity currently being serialized.
     */
    PropertyConverter.prototype.serialize = function (context, value, property, settings) {
        var result = { key: property.name, value: value };
        if (value) {
            if (type_1.isEntityType(property.propertyType)) {
                if (property.isList && Array.isArray(value))
                    result.value = value.map(function (ent) { return ent.serialize(settings); });
                else
                    result.value = value.serialize(settings);
            }
            else if (property.isList)
                result.value = value.slice();
        }
        return result;
    };
    /**
     * Return `IgnoreProperty` to prevent deserialization of the property.
     * @param context The `Entity` containing the specified property.
     * @param prop The current property being deserialized.
     * @param value The value to deserialize.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PropertyConverter.prototype.deserialize = function (context, value, property) {
        return value;
    };
    return PropertyConverter;
}());
exports.PropertyConverter = PropertyConverter;
exports.DefaultSerializationSettings = {
    force: false,
    useAliases: false
};
var EntitySerializer = /** @class */ (function () {
    function EntitySerializer() {
        this._propertyConverters = [];
        this._propertyInjectors = new Map();
        this._propertyAliases = new Map();
        this._valueResolvers = [];
    }
    /**
     * Property converters should be registered in order of increasing specificity.
     * If two converters would convert a property, only the one registered last will apply.
     */
    EntitySerializer.prototype.registerPropertyConverter = function (converter) {
        this._propertyConverters.unshift(converter);
    };
    /**
     * Property injections will occur when serializing entities of the specified type, or entities which
     * inherit from the specified type. Injected properties will appear before model properties in the serialized
     * output.
     * @param type Either a Type or the fullName of a Type
     * @param injector
     */
    EntitySerializer.prototype.registerPropertyInjector = function (type, injector) {
        var injectors = this._propertyInjectors.get(type) || [];
        injectors.push(injector);
        this._propertyInjectors.set(type, injectors);
    };
    EntitySerializer.prototype.registerPropertyAlias = function (type, alias, propertyName) {
        var aliases = this._propertyAliases.get(type) || {};
        aliases[alias] = propertyName;
        aliases[propertyName] = alias;
        this._propertyAliases.set(type, aliases);
    };
    EntitySerializer.prototype.registerValueResolver = function (resolver) {
        this._valueResolvers.push(resolver);
    };
    /**
     * Returns the property injectors registered for a specific type, including name-based registrations.
     * @param type
     */
    EntitySerializer.prototype.getInjectorsOrDefault = function (type) {
        return (this._propertyInjectors.get(type) || []).concat(this._propertyInjectors.get(type.fullName) || []);
    };
    /**
     * Returns property injectors registered for a type and its base types.
     * @param type
     */
    EntitySerializer.prototype.getPropertyInjectors = function (type) {
        var injectors = [];
        do {
            injectors.push.apply(injectors, this.getInjectorsOrDefault(type));
            type = type.baseType;
        } while (type);
        return injectors;
    };
    EntitySerializer.prototype.serializePropertyValue = function (entity, property, value, settings) {
        var converters = this._propertyConverters.filter(function (c) { return c.shouldConvert(entity, property); });
        var result = (function () {
            if (converters) {
                for (var _i = 0, converters_1 = converters; _i < converters_1.length; _i++) {
                    var converter = converters_1[_i];
                    var res = converter.serialize(entity, value, property, settings);
                    if (!settings.force || res !== exports.IgnoreProperty)
                        return res;
                }
            }
            return EntitySerializer.defaultPropertyConverter.serialize(entity, value, property, settings);
        })();
        if (result && result !== exports.IgnoreProperty && settings.useAliases)
            result.key = this.getPropertyAliases(property.containingType)[property.name] || result.key;
        return result;
    };
    /**
     * Produces a JSON-valid object representation of the entity.
     * @param entity
     */
    EntitySerializer.prototype.serialize = function (entity, settings) {
        var _this = this;
        if (settings === void 0) { settings = exports.DefaultSerializationSettings; }
        var result = {};
        var type = entity.meta.type;
        helpers_1.flatMap(this.getPropertyInjectors(type), function (i) { return i.inject(entity); })
            .concat(type.properties
            .filter(function (p) { return !p.isCalculated && !p.isConstant; })
            .map(function (prop) { return _this.serializePropertyValue(entity, prop, prop.value(entity), settings); }))
            .forEach(function (pair) {
            if (pair && pair !== exports.IgnoreProperty) {
                if (result.hasOwnProperty(pair.key))
                    throw new Error("Property '" + pair.key + "' was encountered twice during serialization. Make sure injected properties do not collide with model properties.");
                result[pair.key] = pair.value;
            }
        });
        return result;
    };
    EntitySerializer.prototype.deserialize = function (instance, data, property, context, constructEntity) {
        var _this = this;
        if (constructEntity === void 0) { constructEntity = true; }
        // Apply custom converters before deserializing
        var converter = this._propertyConverters.find(function (c) { return c.shouldConvert(instance, property); });
        if (converter)
            data = converter.deserialize(instance, data, property);
        if (data === exports.IgnoreProperty)
            return;
        var value;
        var resolveEntity = function (type, state) {
            var entity;
            var id = type.meta.identifier ? state[type.meta.identifier.name] : null;
            if (id)
                entity = type.meta.get(id);
            if (!entity)
                entity = new type(id, state, context);
            return entity;
        };
        // Entities
        if (type_1.isEntityType(property.propertyType)) {
            var ChildEntity_1 = property.propertyType;
            if (!constructEntity)
                value = data;
            // Entity List
            else if (property.isList && Array.isArray(data))
                value = data.map(function (s) { return s instanceof ChildEntity_1 ? s : resolveEntity(ChildEntity_1, s); });
            // Entity
            else if (data instanceof ChildEntity_1)
                value = data;
            else if (data instanceof Object)
                value = resolveEntity(ChildEntity_1, data);
            else if (data === null)
                value = data;
        }
        // Value List
        else if (property.isList && Array.isArray(data))
            value = data.map(function (i) { return _this.deserialize(instance, i, property, context); });
        // Value
        else if (property.format && data && typeof (data) === "string" && data.constructor !== property.propertyType)
            value = property.format.convertFromString(data);
        else
            value = data;
        return value;
    };
    EntitySerializer.prototype.getPropertyAliases = function (type) {
        return Object.assign({}, this._propertyAliases.get(type), this._propertyAliases.get(type.fullName));
    };
    EntitySerializer.prototype.resolveProperty = function (context, propName) {
        var prop = context.meta.type.getProperty(propName);
        if (prop)
            return prop;
        propName = this.getPropertyAliases(context.meta.type)[propName];
        return context.meta.type.getProperty(propName);
    };
    EntitySerializer.prototype.resolveValue = function (context, property, value) {
        for (var _i = 0, _a = this._valueResolvers; _i < _a.length; _i++) {
            var resolve = _a[_i];
            var result = resolve(context, property, value);
            if (result)
                return result;
        }
    };
    EntitySerializer.defaultPropertyConverter = new PropertyConverter();
    return EntitySerializer;
}());
exports.EntitySerializer = EntitySerializer;
